import { render, staticRenderFns } from "./PlatformMenuButton.vue?vue&type=template&id=21357a7a&scoped=true"
import script from "./PlatformMenuButton.vue?vue&type=script&lang=ts"
export * from "./PlatformMenuButton.vue?vue&type=script&lang=ts"
import style0 from "./PlatformMenuButton.vue?vue&type=style&index=0&id=21357a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21357a7a",
  null
  
)

export default component.exports